import React, {Component} from 'react';
import TableFilter from '../TableFilter'
import MovimentiTable from './MovimentiTable'
import ErrorMessage from '../ErrorMessage'
import {client} from '../../Client';
import EntrateUsciteFilter from './EntrateUsciteFilter'
// import DataFilter from '../DataFilter'
import EstrattoContoFilter from '../EstrattoContoFilter'
import Moment from 'moment';
import MovimentiReportList from './MovimentiReportList'
import MovimentiListTypeButton from './MovimentiListTypeButton'
import FiltriMultiDropdown from '../FiltriMultiDropdown'
import QueryFilterMovimenti from './QueryFilterMovimenti'
import {createInstance} from '../../Helpers';
import PropTypes from 'prop-types';
import {Header, Modal} from "semantic-ui-react";
import AssegnaDocumentoForm from "./AssegnaDocumentoForm";
import PreviewDocumentoForm from "./PreviewDocumentoForm";
import FileSaver from "file-saver";

class MovimentiList extends Component {
    constructor(props) {
        super(props);
        this.rowperpage = client.getDefaultRowsPerPage();
        this.state = this.getDefaultState();
        this.storeInstance = createInstance();
        this.onChangePage = this.onChangePage.bind(this)
        this.onChangeFilter = this.onChangeFilter.bind(this)
        this.onChangeFilterCommessa = this.onChangeFilterCommessa.bind(this)
        this.onChangeEntrUscite = this.onChangeEntrUscite.bind(this)
        this.onChangeData = this.onChangeData.bind(this)
        this.onChangeEC = this.onChangeEC.bind(this)
        this.onChangeColumnOrder = this.onChangeColumnOrder.bind(this)
        this.onChangeMultiFiltri = this.onChangeMultiFiltri.bind(this)
        this.onChangeQueryFilter = this.onChangeQueryFilter.bind(this)
        this.loadData = this.loadData.bind(this)
        this.onDeleteMovimento = this.onDeleteMovimento.bind(this)
        this.onDocumentAction = this.onDocumentAction.bind(this)
        this.cambiaTipoLista = this.cambiaTipoLista.bind(this)
        this.getStartPageByListViewType = this.getStartPageByListViewType.bind(this)
        this.getFilterDescription = this.getFilterDescription.bind(this)
        this.onAssignDocument = this.onAssignDocument.bind(this)
        this.onAssignDocumentCancel = this.onAssignDocumentCancel.bind(this)
        this.onAssignDocumentSaved = this.onAssignDocumentSaved.bind(this)
        this.onDeleteDocument = this.onDeleteDocument.bind(this)
        this.onPreviewDocument = this.onPreviewDocument.bind(this)
        this.onPreviewDocumentEnd = this.onPreviewDocumentEnd.bind(this)
        this.onExportClick = this.onExportClick.bind(this)
        this.onExportPerBudget = this.onExportPerBudget.bind(this)
        this.onResettaFiltri = this.onResettaFiltri.bind(this)
    }

    isFilterEmpty(filterInfo){
        console.log("Dentro isFilterEmpty: ", filterInfo);
        const f = filterInfo;
        const fPresent = (f.conditions !== undefined && f.conditions !== "") || 
        f.ecEnd !== "" ||
        f.ecStart !== "" ||
        f.entrUsc === "E" || f.entrUsc === "U" ||
        (f.keyword !== undefined && f.keyword !== "") ||
        (f.keywordCommessa !== undefined && f.keywordCommessa !== "") ||
        f.multiFilter.length > 0
        ; 
        return fPresent === false;
    }

    getDefaultState(){
        return {
            items: [],
            total: 0,
            totalPrice: {totaleCorrispettivo: "4121547.21",totalePagamento: "5042587.88"},
            page: 1,
            orderInfo: {
                columnName: 'id',
                direction: 'D',
                data: [{field: 'm.idMovimento', direction: 'D'}]},
            filterInfo: {
                conditions: '',
                multiFilter: [],
                tipo: '365',
                //dataStart: Moment().subtract(365, 'days').format("YYYY-MM-DD"),
                //dataEnd: Moment().format("YYYY-MM-DD"),
                ecStart: Moment().format("YYYY") + "/00/A",
                ecEnd: '' //Moment().format("YYYY") + "/12/A"
            },
            _loading: false,
            error: null,
            listViewType: 'l',
            modalPreview: {size:'large'}
        };
    }

    getFilterDescription(){
        let msg = '';
        if (this.state.filterInfo.dataStart && this.state.filterInfo.dataEnd){
            msg += ' Periodo dal ' + Moment(this.state.filterInfo.dataStart).format('DD/MM/YYYY') +
                ' al ' + Moment(this.state.filterInfo.dataEnd).format('DD/MM/YYYY');
        }
        if (this.state.filterInfo.ecStart){
            msg += ' EC dal ' + this.state.filterInfo.ecStart;
        }
        if (this.state.filterInfo.ecEnd){
            msg += ' EC fino al ' + this.state.filterInfo.ecEnd;
        }

        if (this.state.filterInfo.entrUsc && this.state.filterInfo.entrUsc !== 'All' && this.state.filterInfo.entrUsc !== ''){
            msg += ' Entrate/Uscite: ' + this.state.filterInfo.entrUsc;
        }
        if (this.state.filterInfo.keyword !== undefined && this.state.filterInfo.keyword !== ''){
            msg += ' KW: ' + this.state.filterInfo.keyword + ' ';
        }
        if (this.state.filterInfo.keywordCommessa !== undefined && this.state.filterInfo.keywordCommessa !== ''){
            msg += ' KW COMMESSA: ' + this.state.filterInfo.keywordCommessa + ' ';
        }
        let condAggiuntive = client.getCondizioniAggiuntive(this.state.filterInfo.conditions, this.state.filterInfo.multiFilter)
        if (condAggiuntive){
            msg += ' ' + condAggiuntive;
        }
        return  msg.trim();
    }

    componentWillUnmount() {
        // Segnalati comportamenti anomali. #6 BUG
        if (this.storeInstance) {
            this.storeInstance.save('movimentilist', this.state);
        }
    }

    componentDidMount() {
        if (this.storeInstance && this.storeInstance.restore('movimentilist', this , () => {
            // Stato reimpostato. Ricarica i dati
            this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo);
        }))
        {}
        else{
            this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo);
        }
    }

        // Segnalati comportamenti anomali. #6 BUG
        // if (this.storeInstance && this.storeInstance.restore('movimentilist', this , () => {
        //         if (this.props.location.state && this.props.location.state.item && this.props.location.state.from)
        //         {
        //             if (this.props.location.state.from.pathname.includes("movimenti/edit"))
        //             {
        //                 let movimento = this.props.location.state.item;
        //                 let items = this.state.items.map((cit) => {
        //                     if (cit.idMovimento === movimento.idMovimento)
        //                     {
        //                         return movimento;
        //                     }
        //                     return cit;
        //                 });
        //                 this.setState({items: items});
        //             }
        //             else if (this.props.location.state.from.pathname.includes("movimenti/new"))
        //             {
        //                 let movimento = this.props.location.state.item;
        //                 let items = [movimento];
        //                 this.setState({items: items.concat(this.state.items)});
        //             }
        //
        //         }
        //         else {
        //             this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo);
        //         }
        //     }) === null){
        //     this.loadData(this.state.page,  this.state.orderInfo, this.state.filterInfo);
        // }

        // this.loadData(this.state.page,  this.state.orderInfo, this.state.filterInfo,
        //     ()=> {
        //     if (this.props.location.state && this.props.location.state.item && this.props.location.state.from)
        //         {
        //             if (this.props.location.state.from.pathname.includes("movimenti/edit"))
        //             {
        //                 let movimento = this.props.location.state.item;
        //                 let items = this.state.items.map((cit) => {
        //                     if (cit.idMovimento === movimento.idMovimento)
        //                     {
        //                         return movimento;
        //                     }
        //                     return cit;
        //                 });
        //                 this.setState({items: items});
        //             }
        //             else if (this.props.location.state.from.pathname.includes("movimenti/new"))
        //             {
        //                 let movimento = this.props.location.state.item;
        //                 let items = [movimento];
        //                 this.setState({items: items.concat(this.state.items)});
        //             }
        //
        //         }
        //     });

   // }

    onChangePage(newpage) {
        this.loadData(newpage, this.state.orderInfo, this.state.filterInfo)
    }


    getStartPageByListViewType(){
        return this.state.listViewType === 'l' ? 1 : -1;
    }

    onChangeColumnOrder(columnName, direction, data) {
        let newOrderInfo = {
            columnName: columnName,
            direction: direction,
            data: data
        }
        this.loadData(this.getStartPageByListViewType() , newOrderInfo, this.state.filterInfo)
    }

    onChangeFilter(data){
        let filterInfo = this.state.filterInfo;
        filterInfo.keyword = data.keyword;
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, filterInfo)
    }
    onChangeFilterCommessa(data){
        let filterInfo = this.state.filterInfo;
        filterInfo.keywordCommessa = data.keyword;
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, filterInfo)
    }
    onChangeMultiFiltri(ev, {name, value}){
        let filter = this.state.filterInfo;
        filter.multiFilter = value;
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, filter)
    }

    onChangeQueryFilter(sql){
        let filter = this.state.filterInfo;
        filter.conditions = sql;
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, filter)
    }

    onChangeData(tipo, dataDal, dataAl){
        let filter = this.state.filterInfo;
        filter.dataStart = dataDal !== '' ? dataDal : undefined;
        filter.dataEnd = dataAl !== '' ? dataAl : undefined;
        filter.tipo = tipo;
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, filter)
    }
    onChangeEC(ecDal, ecAl){
        let filter = this.state.filterInfo;
        filter.ecStart = ecDal !== '' ? ecDal : '';
        filter.ecEnd = ecAl !== '' ? ecAl : '';
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, filter, ()=>{
            //console.log("FILTRI: ", this.state);
        })
    }
    onChangeEntrUscite(tipo){
        let filter = this.state.filterInfo;
        filter.entrUsc = tipo;
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, filter)
    }


    loadData(page, orderInfo, filterInfo, cb = null) {
        console.log ("Filtro Vuoto? ", this.isFilterEmpty(filterInfo));
        if (this.isFilterEmpty(filterInfo)){
            this.setState({error: {title: "Filtri non impostati", msg: "Occorre impostare almeno un filtro per poter continuare"}})
            return;
        };
        this.setState({_loading: true});
        client.loadMovimentiList(
            this.rowperpage,
            page,
            orderInfo.data,
            filterInfo
        ).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        items: data.items,
                        total: data.total,
                        totalPrice: data._extras,
                        page: page,
                        orderInfo: orderInfo,
                        filterInfo: filterInfo,
                        _loading: false,
                        error: null
                    }, cb)
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });
    }

    onResettaFiltri(){
        this.setState(
            this.getDefaultState(),
            () => {this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo);}
        );
    }

    onExportClick(tipo){
        this.setState({_loading: true});
        client.exportMovimentiList(
            this.state.orderInfo.data,
            this.state.filterInfo,
            tipo
        ).then((response) => {
            if (response.ok){
                response.blob().then((blob) => {
                    this.setState({_loading: false, error: null})
                    FileSaver.saveAs(blob, 'movimenti.'+tipo);
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });
        });
    }

    onExportPerBudget(format){
        //let format = 'xlsx';
        this.setState({_loading: true});
        client.exportMovimentiPerBudget(
            this.state.filterInfo, format
        ).then((response) => {
            if (response.ok){
                response.blob().then((blob) => {
                    this.setState({_loading: false, error: null})
                    FileSaver.saveAs(blob, 'movimentiperbudget.'+format);
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });
        });
    }

    onDeleteMovimento(ev, movimento){
        this.setState({_loading: true});
        client.deleteMovimento(movimento).then((response) => {
            if (response.ok){
                this.setState({
                    _loading: false,
                    error: null
                });
                this.loadData(this.state.page,  this.state.orderInfo, this.state.filterInfo);
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });
        });

    }

    onDocumentAction(action, movimento){
        // action: download|delete|preview|assign
        switch(action){
            case 'assign':
                this.onAssignDocument(movimento);
                break;
            case 'delete':
                this.onDeleteDocument(movimento);
                break;
            case 'download':
                this.onDownloadDocument(movimento)
                break;
            default:
                this.onPreviewDocument(movimento);
                break;

        }
    }

    onAssignDocument(movimento){
        this.setState({assignDocument: {movimento}})
    }
    onAssignDocumentCancel(movimento){
        this.setState({assignDocument: undefined})
    }
    onAssignDocumentSaved(movimento){
        this.setState({assignDocument: undefined})
        this.loadData(this.state.page,  this.state.orderInfo, this.state.filterInfo);
    }
    onPreviewDocument(movimento){
        this.setState({previewDocument: {movimento}})

    }
    onPreviewDocumentEnd(movimento){
        this.setState({previewDocument: undefined})
    }
    onDownloadDocument(movimento){
        this.setState({_loading: true})
        client.downloadDocumentInMovimento(movimento.idMovimento).then(
            (response) => {
                if (response.ok){
                    response.blob().then((blob) => {
                        this.setState({_loading: false, error: null})
                        FileSaver.saveAs(blob, movimento.nomeDocumento);
                    })
                }
                else if (response.status === 401)
                {
                    this.props.history.push("/login")
                }
                else
                {
                    response.json().then((errore) => {
                        this.setState({
                            _loading: false,
                            error: {title: errore.title, msg: errore.msg},
                        });
                    });
                }
            }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });

        });
    }

    onDeleteDocument(movimento) {
        this.setState({_loading: true});
        client.deleteDocumentoInMovimento(movimento).then((response) => {
            if (response.ok){
                this.setState({
                    _loading: false,
                    error: null
                });
                this.loadData(this.state.page,  this.state.orderInfo, this.state.filterInfo);
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });
        });
    }

    cambiaTipoLista(tipo){
        this.setState({listViewType: tipo}, () => {
            if (tipo === 'r'){
                //Ricarico senza paginazione
                this.loadData(-1, this.state.orderInfo, this.state.filterInfo);
            } else if (this.state.page === -1){
                // Vengo dalla visualzizzazione report, reimposto la pagina a 1
                this.loadData(1, this.state.orderInfo, this.state.filterInfo);
            }
        });
    }
    onLoadingMultiFiltri(){}

    render() {
        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} onDismiss={()=>{this.setState({error:null})}}/>)
        }
        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                <div className="ui loader"></div>
                </div>
            );
        }
        let assignDocument = null;
        if (this.state.assignDocument !== undefined){
            assignDocument = (
                <Modal style={{height:'80%'}}
                    open={this.state.assignDocument !== undefined}
                >
                <Header icon='add' content='Assegna un documento al Movimento' />
                <Modal.Content style={{height: "100%"}}>

                    <AssegnaDocumentoForm
                        item={this.state.assignDocument.movimento}
                        onUndoClick={this.onAssignDocumentCancel}
                        onSaveClick={this.onAssignDocumentSaved}
                    />

                </Modal.Content>
            </Modal>)
        }
        let previewDocument = null;
        if (this.state.previewDocument !== undefined){
            previewDocument = (<Modal
                style={{height:'80%'}}
                open={this.state.previewDocument !== undefined}
                size={this.state.modalPreview.size}
                closeIcon
                onClose={this.onPreviewDocumentEnd}
            >
                <Header icon='file outline' content={'Anteprima Documento associato al Movimento - [' + this.state.previewDocument.movimento.nomeDocumento + ']'} />
                <Modal.Content style={{height:'80%'}}>
                <PreviewDocumentoForm
                    item={this.state.previewDocument.movimento}
                    showButtons={true}
                    onOkClick={this.onPreviewDocumentEnd}
                />
                </Modal.Content>
            </Modal>)
        }
        return (<div className="ui">
            <h3 className="ui top block attached header">
                <div className="ui three column grid">
                    <div className="column">
                        <div className="ui green label">{this.state.total}</div> Movimenti soddisfano i filtri specificati

                    </div>
                    <div className="column">
                        <div className="ui ">
                            <button className="ui  button" onClick={() => this.onResettaFiltri()}>
                                <i className="delete icon"></i>Reimposta i filtri</button>
                        </div>
                    </div>
                    <div className="right aligned column">
                        <div className="ui ">
                            <MovimentiListTypeButton
                                listType={this.state.listViewType}
                                onButtonClick={(t) => {this.cambiaTipoLista(t)}}
                            />
                        </div>
                    </div>
                </div>
            </h3>
            <div className="ui attached segment">

            <div className="ui stackable grid ">

                <div className="six wide column">
                    <EntrateUsciteFilter
                        letter={this.state.filterInfo.entrUsc}
                        onChange={this.onChangeEntrUscite}
                    />
                </div>
                <div className="ten wide column">
                    <EstrattoContoFilter
                        itemDal={this.state.filterInfo.ecStart}
                        itemAl={this.state.filterInfo.ecEnd}
                        onChange={this.onChangeEC}
                    />
                </div>

                <div className="eight wide column">
                    <TableFilter
                        showPopup={true}
                        value={this.state.filterInfo.keyword}
                        placeholder="Filtra per id, causale, soggetto, estratto conti, piano dei conti, forma di pagamento..."
                        onChangeFilter={this.onChangeFilter}
                    />

                </div>
                <div className="eight wide column">
                    <TableFilter
                        showPopup={true}
                        value={this.state.filterInfo.keywordCommessa}
                        placeholder="Filtra per codice commessa..."
                        onChangeFilter={this.onChangeFilterCommessa}
                    />

                </div>
                <div className="eight wide column">
                    <FiltriMultiDropdown tipo="MOV" name='filtri'
                                         value={this.state.filterInfo.multiFilter}
                                         onChange={this.onChangeMultiFiltri}
                                         onLoading={this.onLoadingMultiFiltri}
                    />
                </div>
                <div className="eight wide column">
                    <QueryFilterMovimenti
                        tipo="QRYM1"
                        showPopup={true}
                        popupPosition="left center"
                        value={this.state.filterInfo.conditions}
                        placeholder="Condizione SQL-like..."
                        onChangeFilter={this.onChangeQueryFilter}
                    />
                </div>
            </div>
            </div>
            {
                this.state.listViewType === 'l' ?
                    <MovimentiTable
                        items={this.state.items}
                        count={this.state.total}
                        page={this.state.page}
                        totalPrice={this.state.totalPrice}
                        rowperpage={this.rowperpage}
                        tableOrderingField={this.state.orderInfo.columnName}
                        tableOrderingDirection={this.state.orderInfo.direction}
                        onChangePage={this.onChangePage}
                        onChangeOrder={this.onChangeColumnOrder}
                        onDeleteItem={this.onDeleteMovimento}
                        onDocumentAction={this.onDocumentAction}
                        filterDescription={this.getFilterDescription()}
                        onExport={this.onExportClick}
                        onExportPerBudget={this.onExportPerBudget}
                        readOnly={client.getCurrentUser().isrolemovimentiw===false}
                    />
                    :<MovimentiReportList
                        items={this.state.items}
                        totalPrice={this.state.totalPrice}
                        filterDescription={this.getFilterDescription()}
                        onExportPerBudget={this.onExportPerBudget}
                    />
            }
            {assignDocument}
            {previewDocument}
            {loader}
        </div>)
    }
}

MovimentiList.contextTypes = {
    router: PropTypes.object
}

export default MovimentiList;




/** WEBPACK FOOTER **
 ** ./src/components/movimenti/MovimentiList.js
 **/